// extracted by mini-css-extract-plugin
export default {"ModalCloseStyle":"login-logout_ModalCloseStyle__iqYtF","SignInLinkStyle":"login-logout_SignInLinkStyle__Dg-8h"};